export function toggleActive(el) {
	if (!el) {
		return;
	}

	/* eslint-disable no-unused-expressions */
	el.classList.contains('active')
		? el.classList.remove('active')
		: el.classList.add('active');
}
